<template>
  <div>
    <!-- SLOT NON DISPONIBILE / DISABILITATO -->
    <template v-if="slot.booked || !slot.active">
      <!-- Non prenotato ma disabilitato/chiuso -->
      <template v-if="!slot.booked">
        <v-btn
            depressed
            color="error"
            outlined
            disabled
            block
        >
          <span
              class="time-slot"
              :style="slot.closed ? 'color:#ffacac' : ''"
          >
            {{ slot.start }} - {{ slot.end }}<br>
            <small
                v-if="slot.closed"
                style="font-size: 9px"
            >
              CHIUSO
            </small>
          </span>
        </v-btn>
        <template
            v-if="showConfigButton"
        >
          <div style="text-align: center; margin-top: -6px;">
            <v-btn
                elevation="2"
                raised
                tile
                x-small
                color="error"
                @click.stop="onOverride"
            >
              CONFIGURA
            </v-btn>
          </div>
        </template>
      </template>

      <!-- Prenotato -->
      <template v-else>
        <div
            :class="(slot.fixed_booked || slot.from_fixed_booking) ? 'orange white--text' : 'info white--text'"
            style="cursor: pointer; border-radius: 5px"
            @click="onBook"
        >
          <span
              class="time-slot"
              style="max-width: 140px; margin: 0 auto; min-height: 45px"
          >
            <v-icon
                v-if="slot.added_30_min_before || slot.added_30_min_after"
                small
            >
              mdi-clock-plus-outline
            </v-icon>
            {{ slot.start }} - {{ slot.end }}<br>
            <div style="font-size: 13px; font-weight: normal">
              <template v-if="slot.user_id">
                <v-icon x-small color="white">mdi-account</v-icon>
                {{ slot.customer && slot.customer[0] ? slot.customer[0].name : '' }}
                {{ slot.customer && slot.customer[0] ? slot.customer[0].surname : '' }}
              </template>
              <template v-else>
                <v-icon x-small color="white">mdi-file-document-edit-outline</v-icon>
                {{ cleanedNote }}
              </template>
              <template
                  v-if="(slot.fixed_booked || slot.from_fixed_booking) && slot.note && !slot.note.toLowerCase().includes('fisso')"
              >
                <p>Fisso</p>
              </template>
            </div>
          </span>
        </div>
      </template>
    </template>

    <!-- SLOT ATTIVO NON PRENOTATO -->
    <template v-else>
      <!-- PROMO NORMALE -->
      <template v-if="slot.promo && !slot.promo_sa">
        <v-alert
            color="primary"
            outlined
            block
            class="btn-slot promo"
            @click="onBook"
        >
          <span
              class="promo-amount"
              v-if="slot.promo"
          >
            -{{ slot.promo.value }}{{ slot.promo.type === 'fixed' ? '€' : '%' }}
          </span>
          <span class="time-slot">
            {{ slot.start }} - {{ slot.end }}
          </span>
          <span class="price-promo">
            {{ totalPrice.toFixed(2) }} €
          </span>
          <span
              v-if="onlinePrice === 0"
              class="label-pay"
          >
            Pagamento Al Campo
          </span>
          <span
              v-else-if="centerPrice === 0"
              class="label-pay"
          >
            Paghi comodo online
          </span>
          <span
              v-else
              style="font-size: 10px; display: block; text-align: center"
          >
            di cui {{ onlinePrice.toFixed(2) }} € online
          </span>
        </v-alert>
      </template>

      <!-- PROMO SUPERADMIN -->
      <template v-else-if="slot.promo_sa">
        <v-alert
            color="primary"
            outlined
            block
            class="btn-slot promo_sa"
        >
          <span
              class="promo-amount"
              v-if="slot.promo"
          >
            -{{ slot.promo.value }}{{ slot.promo.type === 'fixed' ? '€' : '%' }}
          </span>
          <span class="time-slot">
            {{ slot.start }} - {{ slot.end }}
          </span>
          <span class="price-promo_sa">
            {{ totalPrice.toFixed(2) }} €
          </span>
          <span class="label-pay-yellow blink">
            PROMO PER POCHE ORE
          </span>
        </v-alert>
      </template>

      <!-- SLOT NORMALE -->
      <template v-else>
        <v-alert
            color="primary"
            outlined
            block
            class="btn-slot normal"
        >
          <div @click="onBook">
            <span class="time-slot">
              {{ slot.start }} - {{ slot.end }}
            </span>
            <span class="price">
              {{ totalPrice.toFixed(2) }} €
            </span>
            <span
                v-if="onlinePrice === 0"
                class="label-pay"
            >
              Pagamento Al Campo
            </span>
            <span
                v-else-if="centerPrice === 0"
                class="label-pay"
            >
              Paghi comodo online
            </span>
            <span
                v-else
                style="font-size: 10px; display: block; text-align: center"
            >
              di cui {{ onlinePrice.toFixed(2) }} € online
            </span>
          </div>
        </v-alert>
      </template>

      <!-- BOTTONE CONFIGURA -->
      <template
          v-if="showConfigButton"
      >
        <div style="text-align: center; margin-top: -6px;">
          <v-btn
              elevation="2"
              raised
              tile
              x-small
              color="error"
              @click.stop="onOverride"
          >
            CONFIGURA
          </v-btn>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SlotCell',
  props: {
    slotObj: { type: Object, required: true },
    dayKey: { type: String, required: true },
    fieldObj: { type: Object, required: true },
    getPrice: { type: Function, required: true },
    getAvailabilityNow: { type: Function, required: true },
    removeText: { type: Function, required: true },
  },
  computed: {
    slot() {
      return this.slotObj;
    },
    field() {
      return this.fieldObj;
    },
    onlinePrice() {
      return this.getPrice(this.slot, this.field._id, 'online') || 0;
    },
    centerPrice() {
      return this.getPrice(this.slot, this.field._id, 'center') || 0;
    },
    totalPrice() {
      return this.getPrice(this.slot, this.field._id, 'total') || 0;
    },
    cleanedNote() {
      if (!this.slot.note) return '';
      return this.removeText(this.slot.note, 'Prenotazione Manuale');
    },
    showConfigButton() {
      return (
          !this.slot.booked &&
          this.getAvailabilityNow(this.dayKey, this.slot.slot_id, this.field) &&
          !this.slot.overlap &&
          !this.slot.exclude &&
          !this.slot.closed
      );
    }
  },
  methods: {
    onBook() {
      // emit con stessa firma che usi nel padre
      this.$emit('book', this.slot, null, null, this.dayKey, this.field);
    },
    onOverride() {
      this.$emit('override', this.dayKey, this.slot, this.field);
    }
  }
};
</script>

<style scoped>
.time-slot {
  font-weight: 700;
  font-size: 13px;
  width: 100%;
  display: block;
  text-align: center;
}

.price {
  width: 100%;
  display: block;
  text-align: center;
  color: #00752a;
  font-size: 13px;
  font-weight: 600;
}

.price-promo {
  width: 100%;
  display: block;
  text-align: center;
  color: red;
  font-size: 13px;
  font-weight: 600;
}

.price-promo_sa {
  width: 100%;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.label-pay {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  color: darkblue;
  text-transform: uppercase;
}

.label-pay-yellow {
  text-align: center;
  font-size: 10px;
  display: block;
  font-weight: 600;
  text-transform: uppercase;
  color: #baff3b;
}

.btn-slot {
  padding: 0 8px;
  height: 60px;
  margin: 6px 0;
  border: none !important;
  cursor: pointer;
}

.btn-slot.normal {
  background: #25a63936 !important;
}

.btn-slot.promo {
  background: rgb(40 43 80 / 10%) !important;
  animation: pulse-shadow 2s infinite;
}

.btn-slot.promo_sa {
  background: #282b50 !important;
  color: #fff !important;
  animation: pulse 1.25s infinite ease-out;
}

.promo-amount {
  background: red;
  color: #fff;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 3px;
  font-size: 13px;
  padding: 0 4px;
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1.0);
  }
  50% {
    transform: scale(1.15);
  }
  100% {
    transform: scale(1.0);
  }
}

@keyframes pulse-shadow {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 0 rgba(206, 67, 67, 0.48);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 2px rgba(206, 67, 67, 0.48);
  }
}
</style>
